import React from 'react';
import Modal from 'react-modal';

const CHAR_COUNT_TO_SHOW_ON_DEL_MODAL = 60;

const DeletionModal = ({
  smartLink,
  isOpen,
  isDeleting,
  close,
  handleDeleteSubmit,
}) => {
  const setClose = () => close(false);

  let responseTextPreview = smartLink.messageText;
  if (responseTextPreview && responseTextPreview.length > CHAR_COUNT_TO_SHOW_ON_DEL_MODAL) {
    responseTextPreview = `${smartLink.messageText.substring(0, CHAR_COUNT_TO_SHOW_ON_DEL_MODAL)}...`;
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={setClose}
      className="modal small"
      overlayClassName="modal-overlay"
      contentLabel="Delete Smart Link"
    >
      <div className="upsell-modal">
        <span className="title">
          Delete
        </span>
        <p>
          Are you sure you want to delete this Smart Link with response &quot;
          {responseTextPreview}
          &quot;
          ?
        </p>
        <button
          className="btn btn-red delete-upsell-btn"
          onClick={() => handleDeleteSubmit(smartLink.id)}
          type="button"
          disabled={isDeleting}
        >
          Delete
        </button>
        <button className="btn btn-link" onClick={setClose} type="button">cancel</button>
      </div>
    </Modal>
  );
};

export default DeletionModal;
